import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

export interface VatIntegrationForm {
  contactInitials: string
  contactSurnamePrefix?: string
  contactSurname: string
  taxIdentificationNumber: string
  authorization: boolean
}

export const getDefaultValues = (organization?: Organization): VatIntegrationForm => ({
  contactInitials: '',
  contactSurnamePrefix: '',
  contactSurname: '',
  taxIdentificationNumber: organization?.vatNo || '',
  authorization: false,
})

export type VatIntegrationFormSchema = ZodType<VatIntegrationForm>

export const getVatIntegrationFormSchema = (t: TFunction): VatIntegrationFormSchema =>
  z.object({
    contactInitials: z.string().nonempty({ message: t('vat_declarations.integration_form.form.missing_initials') }),
    contactSurnamePrefix: z.string().optional().or(z.literal('')),
    contactSurname: z.string().nonempty({ message: t('vat_declarations.integration_form.form.missing_lastname') }),
    taxIdentificationNumber: z
      .string()
      .nonempty({ message: t('vat_declarations.integration_form.form.missing_vatNo') })
      .regex(/^(NL)?\d{9}B\d{2}$/, { message: t('vat_declarations.integration_form.form.vatNo_invalid_format') }),
    authorization: z.literal(true, {
      errorMap: () => ({ message: '' }),
    }),
  })
